import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";

import UpsertBrand from "./UpsertBrand.graphql";
import Brand from "../../features/brands/domain/Brand";

export default function useUpsertBrand(brand: Brand) {
    return useMutation(
        gql(UpsertBrand),
        {
            refetchQueries: ["BrandsForBrandsConsole"],
            variables: {
                brand: {
                    about: brand.about?.map(({ language, text }) => ({ language, text })),
                    address: brand.address ? {
                        street: brand.address.street,
                        city: brand.address.city,
                        zipCode: brand.address.zipCode,
                        country: brand.address.country,
                    } : brand.address,
                    alternativeNames: brand.alternativeNames,
                    arbitraryData: brand.arbitraryData,
                    color: brand.color,
                    coverImage: brand.coverImage,
                    enableCatalog: brand.enableCatalog,
                    features: brand.features,
                    legacyAlias: brand.legacyAlias,
                    legacyID: brand.legacyID,
                    logo: brand.logo,
                    name: brand.name,
                    primaryLanguage: brand.primaryLanguage,
                    url: brand.url,
                },
                id: brand.id,
            },
        },
    );
}
